import { jsx as e, jsxs as o } from "react/jsx-runtime";
import R, { useRef as T, useMemo as C } from "react";
import { Avatar as O } from "./index.es5477.js";
import { useIsTextOverflowing as h } from "@placer-ui/hooks";
import p from "classnames";
import r from "./index.es5478.js";
import { Dropdown as $ } from "./index.es66.js";
import { IconButton as M } from "./index.es12.js";
import { BodyText as f } from "./index.es487.js";
import { Heading as S } from "./index.es489.js";
import { SimpleTooltip as g } from "./index.es120.js";
import { Icon as b } from "./index.es147.js";
import { TinyText as A } from "./index.es493.js";
import { BasicDropdownMenu as D } from "./index.es67.js";
import { UtilityMoreIcon as B } from "./index.es440.js";
const V = ({
  name: d,
  roles: n,
  address: c,
  onSelect: v,
  menuItems: t,
  testId: a,
  isWrapping: l
}) => {
  const { isOverflowing: u, textElmRef: m } = h(), { isOverflowing: N, textElmRef: w } = h(), x = p(r.rolesContainer, {
    [r.isWrapping]: l
  }), E = p(r.header, {
    [r.withDots]: !!(t != null && t.length),
    [r.isWrapping]: l
  }), s = T(""), y = C(() => (s.current = n[0], l ? /* @__PURE__ */ e("div", { children: n.slice(0, n.length).map((i) => (s.current += ` • ${i}`, /* @__PURE__ */ o(f, { element: "p", children: [
    /* @__PURE__ */ e("span", { className: r.dot, children: "•" }),
    /* @__PURE__ */ e("span", { className: r.role, children: i })
  ] }, i))) }) : /* @__PURE__ */ o(f, { element: "p", isEllipsis: !0, ref: m, children: [
    /* @__PURE__ */ e("span", { className: r.role, children: s.current }),
    n.slice(1, n.length).map((i) => (s.current += ` • ${i}`, /* @__PURE__ */ o(R.Fragment, { children: [
      /* @__PURE__ */ e("span", { className: r.dot, children: "•" }),
      /* @__PURE__ */ e("span", { className: r.role, children: i })
    ] }, i)))
  ] })), [l, n, m]);
  return /* @__PURE__ */ o("div", { className: E, "data-testid": a, children: [
    /* @__PURE__ */ e(O, { name: d, testId: `${a}-avatar`, headingElement: "h1" }),
    /* @__PURE__ */ o("div", { className: r.mainDetails, "data-testid": `${a}-main-details`, children: [
      /* @__PURE__ */ e(S, { variant: "h5", "data-testid": `${a}-heading`, element: "h2", children: d }),
      /* @__PURE__ */ e("div", { className: x, children: /* @__PURE__ */ e(
        g,
        {
          title: s.current,
          isActive: u,
          children: y
        }
      ) }),
      c && /* @__PURE__ */ o("div", { className: r.addressContainer, "data-testid": `${a}-address`, children: [
        /* @__PURE__ */ e(b, { size: 16, type: "MapPinLine", color: "gray" }),
        /* @__PURE__ */ e(g, { title: c, isActive: N, children: /* @__PURE__ */ e(
          A,
          {
            variant: "address",
            color: "secondary",
            isEllipsis: !l,
            ref: w,
            children: c
          }
        ) })
      ] })
    ] }),
    (t == null ? void 0 : t.length) && /* @__PURE__ */ e("div", { className: r.btnWrapper, children: /* @__PURE__ */ e(
      $,
      {
        closeOnSelection: !0,
        align: "start",
        side: "bottom",
        trigger: /* @__PURE__ */ e(
          M,
          {
            "aria-label": "toggle header dropdown",
            variant: "ghost",
            Icon: /* @__PURE__ */ e(B, {})
          }
        ),
        testId: "contact-card-header-dropdown-button",
        menuWidth: 80,
        triggerMerge: !0,
        triggerWrapper: "none",
        children: /* @__PURE__ */ e(D, { items: t, onItemSelection: v })
      }
    ) })
  ] });
};
export {
  V as Header
};
//# sourceMappingURL=index.es689.js.map
